import React, { useState, useEffect } from "react";
import { PRODUCT_API } from "../../data/api";
import { Link } from "react-router-dom";

const SellerProducts = () => {
  const [products, setProducts] = useState([]);
  const [editProduct, setEditProduct] = useState(null);
  const [formData, setFormData] = useState({ productName: "", price: "", quantity: "" });
  const [showForm, setShowForm] = useState(false);

  const vendorId = Number(localStorage.getItem("vendorId"));

  const fetchProducts = async () => {
    try {
      const res = await fetch(PRODUCT_API.GET_BY_VENDOR(vendorId));
      if (!res.ok) throw new Error("Failed to fetch products");
      const data = await res.json();
      setProducts(data);
    } catch (err) {
      console.error("Error fetching products:", err);
      setProducts([]);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleDelete = async (productId) => {
    try {
      const res = await fetch(PRODUCT_API.DELETE(productId), { method: "DELETE" });
      if (res.ok) {
        setProducts(products.filter((p) => p.productId !== productId));
        alert("Product deleted!");
      } else {
        alert("Delete failed!");
      }
    } catch (err) {
      console.error(err);
      alert("Delete failed!");
    }
  };

  const handleEdit = (product) => {
    setEditProduct(product);
    setFormData({
      productName: product.productName,
      price: product.price,
      quantity: product.quantity,
    });
    setShowForm(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

 const handleUpdate = async (e) => {
  e.preventDefault();

  try {
    const payload = {
      productId: editProduct.productId,
      vendorId: vendorId,

      productName: formData.productName,
      price: Number(formData.price),
      quantity: Number(formData.quantity),

      // 👇 baki fields backend ke liye REQUIRED
      productType: editProduct.productType ?? "",
      status: editProduct.status ?? "Active",
      capacityKG: editProduct.capacityKG ?? 0,
      speedMPS: editProduct.speedMPS ?? 0,
      machineRoomType: editProduct.machineRoomType ?? "",
      doorType: editProduct.doorType ?? "",
      floorsSupported: editProduct.floorsSupported ?? 0,
      warrantyYears: editProduct.warrantyYears ?? 0,
      powerConsumption: editProduct.powerConsumption ?? "",
      description: editProduct.description ?? "",
      features: editProduct.features ?? "",
      isCustomizable: editProduct.isCustomizable ?? false,
      imageURLs: editProduct.imageURLs ?? [],
    };

    const res = await fetch(PRODUCT_API.UPDATE(editProduct.productId), {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const err = await res.text();
      console.error("Update error:", err);
      alert("Update failed!");
      return;
    }

    alert("✅ Product updated!");

    setProducts((prev) =>
      prev.map((p) =>
        p.productId === editProduct.productId
          ? { ...p, ...payload }
          : p
      )
    );

    setShowForm(false);
    setEditProduct(null);
  } catch (err) {
    console.error(err);
    alert("Update failed!");
  }
};


  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Manage Products</h1>
        <Link
          to="/____seller_dashboard/addProducts"
          className="bg-blue-600 text-white px-5 py-2 rounded-lg hover:bg-blue-700 transition"
        >
          + Add Product
        </Link>
      </div>

      {/* Edit Form */}
      {showForm && (
        <div className="bg-white p-6 rounded-xl shadow mb-6">
          <h2 className="text-xl font-semibold mb-4">Edit Product</h2>
          <form onSubmit={handleUpdate} className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <input
              type="text"
              name="productName"
              value={formData.productName}
              onChange={handleChange}
              placeholder="Product Name"
              className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
              required
            />
            <input
              type="number"
              name="price"
              value={formData.price}
              onChange={handleChange}
              placeholder="Price"
              className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
              required
            />
            <input
              type="number"
              name="quantity"
              value={formData.quantity}
              onChange={handleChange}
              placeholder="Quantity"
              className="border p-3 rounded-lg focus:ring-2 focus:ring-blue-400 outline-none"
              required
            />
            <div className="md:col-span-3 flex justify-end mt-4 gap-3">
              <button
                type="button"
                className="px-6 py-2 rounded-lg bg-gray-300 hover:bg-gray-400 text-gray-800 transition"
                onClick={() => { setShowForm(false); setEditProduct(null); }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-6 py-2 rounded-lg bg-yellow-600 hover:bg-yellow-700 text-white transition"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Products Table */}
      <div className="bg-white rounded-xl shadow p-4">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b">
              <th className="py-3 px-2">Product</th>
              <th className="py-3 px-2">Price</th>
              <th className="py-3 px-2">Qty</th>
              <th className="py-3 px-2">Action</th>
            </tr>
          </thead>
          <tbody>
            {products.length > 0 ? (
              products.map((p) => (
                <tr key={p.productId} className="border-b hover:bg-gray-50">
                  <td className="py-3 px-2">{p.productName}</td>
                  <td className="py-3 px-2">₹{p.price}</td>
                  <td className="py-3 px-2">{p.quantity}</td>
                  <td className="py-3 px-2 flex gap-3">
                    <button
                      className="px-3 py-1 bg-yellow-100 text-yellow-700 rounded-lg hover:bg-yellow-200 transition"
                      onClick={() => handleEdit(p)}
                    >
                      Edit
                    </button>
                    <button
                      className="px-3 py-1 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition"
                      onClick={() => handleDelete(p.productId)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center text-gray-500 py-4">
                  No products found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SellerProducts;
